<template>
  <router-link
    class="session d-flex align-items-center link--naked"
    v-bind="$attrs"
    :to="{ name: 'Profile', params: { locale } }"
    @click="emit('click')"
    v-if="isAuthenticated"
  >
    <slot
      name="user"
      :user="authUser"
    >
      <app-avatar
        class="session__avatar"
        size="2"
        :avatar="authUser.avatar"
        v-if="icon"
      />

      <span
        class="session__text margin__l--6"
        v-if="text"
      >
        {{ authUser.firstname }}
      </span>
    </slot>
  </router-link>

  <button
    class="session link--naked"
    v-bind="$attrs"
    @click.prevent="openModal()"
    v-else
  >
    <slot name="login">
      <slot name="icon">
        <fa-icon
          class="session__icon"
          :icon="['fas', 'user']"
          v-if="icon"
        />
      </slot>

      <span
        class="session__text margin__l--6"
        v-if="text"
      >
        {{ t('literal.login') }}
      </span>
    </slot>
  </button>

  <session-modal
    size="sm"
    :tab="tab"
    @close="handleModalClose()"
    v-if="show_modal"
  />
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthenticationStore } from '@/stores/AuthenticationStore'
import { useLanguageStore } from '@/stores/LanguageStore'
import { useModals } from '@/composables/app/useModals'
import { useI18n } from '@/vendors/i18n'

const AppAvatar = defineAsyncComponent(() => import('&/atoms/AppAvatar'))
const SessionModal = defineAsyncComponent(() => import('&/organisms/SessionModal'))

const emit = defineEmits(['click', 'close'])

defineProps({
  tab: { type: String, default: 'login' },
  icon: { type: Boolean, default: true },
  text: { type: Boolean, default: true }
})

const { t } = useI18n()
const { authUser, isAuthenticated } = storeToRefs(useAuthenticationStore())
const { locale } = storeToRefs(useLanguageStore())
const { show_modal, openModal, closeModal } = useModals()

const handleModalClose = () => {
  closeModal()

  emit('close')
}
</script>